import React, {useState, useRef, Suspense, useMemo} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import ModalPopup from 'components/modal/';
import useToggleState from 'components/hooks/useToggleState';
import UIDatePicker from "components/datepicker";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import PageLoading from "components/loading";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "components/UI";
import use from "common/hooks/use";

function ContentsContainer() {
    const location = useLocation();
    const history = useHistory();

	const [tbAgree, setTbAgree] = React.useState<{id:number; text:string; guide:string; checked?:boolean }[]>([
		{id:1,text:'위의 안내사항에 동의합니다.',guide:'안내'  ,checked: false},
		{id:2,text:'승인된 과제계획서과 실제지급내용이 상이한경우, 지급신청이 반려될 수 있습니다.',guide:'지급근거',checked: false},
		{id:3,text:'수혜 중소기업의 자격(중소기업확인서 등) 유효기간이 지난 증빙자료를 제출하시면 지급신청이 반려될 수 있습니다.',guide:'지원대상',checked: false},
		{id:4,text:'출연기업을 대상으로 매입계산서를 발행하지 않아야하며, 매출로 계상할 수 없습니다.',guide:'회계처리',checked: false},
		{id:5,text:'수혜 중소기업에게 직접 상생협력기금을 지급하는 경우, 향후 세금환급이 가능한 VAT 등은 제외한 공급가액만 지원합니다.',guide:'회계처리',checked: false},
		{id:6,text:'VAT등의 지급을 위하여 수행기관 등을 부정 등록하는 경우, 상생협력기금이 환수 될 수 있습니다.',guide:'지급확인',checked: false},
		{id:7,text:'수혜 중소기업과 출연기업이 특수관계가 아님을 확인하였습니다.',guide:'지급근거',checked: false},
	]);

    const contentObj = useMemo(() => CommonUtil.execute({
        url: 'usr_2114',
    }).then((response:any) => {
        const result = response;

        const tempFileValue = new TbComFile();
        tempFileValue.setTbComFileMapngDetailList([]);

        const fileList = result.FILE_INFO;
        for(const fileInfo of fileList){
            //파일등록 정보
            const fileDetail = new TbComFileMapngDetail();
            fileDetail.setDwldId(fileInfo.DWLD_ID);
            fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
            fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
            fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
            fileDetail.setStrePath(fileInfo.STRE_PATH);
            fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
            fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
            fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
            fileDetail.setFileSize(fileInfo.FILE_SIZE);
            fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
            fileDetail.setRegistDt(fileInfo.REGIST_DT);
            tempFileValue.putTbComFileMapngDetailList(fileDetail);
        }

        return {
            title: result.PAY_CALL_TITLE,
            cont: result.PAY_CALL_CONT,
            fileId: result.FILE_ID,
            fileValue: tempFileValue
        }
    }).catch((error) => {
        CommonUtil.showAxiosError(error);
        return;
    }), []);

    const [isAllChk,setIsAllChk] = useState(false);

    const modalusr2115 = useToggleState({});
    const [modal2115IsOpen, setModal2115IsOpen] = useState(false);

    const [tskReqNm, setTskReqNm] = useState('');
    const [tskNm, setTskNm] = useState('');
    const [tskReqNo, setTskReqNo] = useState('');

    const [stDate, setStDate] = useState(new Date(new Date().getFullYear()-1+'-01-01'));
    const [enDate, setEnDate] = useState(new Date(new Date().getFullYear()+'-12-31'));

    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count

    // const [loadFinish, setLoadFinish] = useState(false);


    //초기 데이터 설정
    let totalCnt:number = 0;

    function isChecked(element)  {
        if(element.checked == false)  {
            return true;
        }
    }

    const checkBoxHandler = (e) => {

        let newList = [...tbAgree];

        if(e.target.id === 'ch-all'){
            setIsAllChk(e.target.checked);
        }else{
            newList[Number(e.target.id.replace('ch-t', ''))-1].checked = e.target.checked;
        }

        if(e.target.id != 'ch-all'){
            let isAll = false;

            if(tbAgree.find(isChecked) == undefined){
                isAll = true;
            }
            setIsAllChk(isAll);
            setTbAgree(newList);
        }else{
            let allCheckBol = e.target.checked;
            newList = newList.map(e => {
                e.checked = allCheckBol;
                return e;
            });
            setTbAgree(newList);
        }

    };

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            <span className="fc-pri">*</span> 전체동의가 필요합니다.
        </>);
    }



    //====== 그리드 공통 부 START
    var ib = ib||{};
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 20,
                "Alternate": 2,
                "AutoRowHeight": true,
                "InfoRowConfig": "0",
                "UseButton": 1       // <button>태그를 사용하여 버튼 생성
            },
                //틀고정 좌측 컬럼 설정
                "LeftCols": [
                {"Header": "No","Name": "SEQ","Width": "90"}
                ],
            "Cols": [
                {"Header": "SEQ","Type": "Int", "Name": "TSK_REQ_MODI_SEQ","Align": "Center","RelWidth": 0.5,"CanEdit": "0", Visible: 0},
                {"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
                {"Header": "과제명","Type": "Text","Name": "TSK_NM","RelWidth": 3,"Align": "Center","CanEdit": "0"},
                {"Header": "과제번호","Type": "Text", "Name": "TSK_REQ_NO","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
                {"Header": "신청자","Type": "Text","Name": "TSK_REQ_USERNM","RelWidth": 1,"Align": "Center","CanEdit": "0"},
                {"Header": "과제시작일","Type": "Text","Name": "TSK_ST_DATE","RelWidth": 1.5,"Align": "Center","CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd"},
                {"Header": "과제종료일","Type": "Text","Name": "TSK_EN_DATE","RelWidth": 1.5,"Align": "Center","CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd"},
                {"Header": "신청가능금액","Type": "Int","Name": "REQ_AMT","RelWidth": 2,"Align": "Right","Format": "#,##0"},
                {"Header": "선택","Type": "Html","Name": "SELECT","RelWidth": 2,"Align": "Center" , "HtmlPostfix" : '<button class="bt" data-color="pri" data-size="tn" type="button" >선택</button>'},
                {"Header": "수행기관여부","Type": "Text", "Name": "PERF_CORP_YN","Align": "Center","RelWidth": 0.5,"CanEdit": "0", Visible: 0},
            ]
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //초기 데이터 로딩
                doSearch('init');
            },
            // 클릭 이벤트
            onAfterClick:function(evtParam){
                // @ts-ignore
                let row = sheet.getFocusedRow();

                let dataToSend = { tskReqNo: row["TSK_REQ_NO"],
                                   tskReqModiSeq: row["TSK_REQ_MODI_SEQ"],
                                   perfCorpYn: row["PERF_CORP_YN"],
                                   reqAmt: row["REQ_AMT"],
                                 };

                console.log(dataToSend);

                //다른 페이지로 이동하면서 데이터 전달
                // if(row["PERF_CORP_YN"] == "N") {    // 수행기업 없으면
                //     // 지원기업 목록으로 이동
                //     history.push({
                //         pathname: './usr_2116',
                //         state: { data: dataToSend }
                //     });
                // } else {
                //     // 수행기업 + 지원기업 목록으로 이동
                //     history.push({
                //         pathname: './usr_2118',
                //         state: { data: dataToSend }
                //     });
                // }

                history.push({
                    pathname: './usr_2119',
                    state: { data: dataToSend }
                });


                // 팝업 Close
                onClose();
            },
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                _data = JSON.stringify(d.slice(0, 20), null, 2);
                _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                _data = JSON.stringify(d, null, 2);
                }

            },
            onAfterGotoPage:function (evtParam) {

                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                //@ts-ignore
                if (currentPage != -1 && currentPage != page) {
                  makePageIndex(page);
                }

            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;

            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: this.data // 생성될 시트의 정적데이터
            });
            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //화면 기능
        'sampleBtn':function (showRowCnt) {
            this.init.PageLength = showRowCnt;
            ib.create();
        },
        //조회 데이터
        'data':[]
    }

    //====== 그리드 공통 부  END

    //====== 그리드 데이터 가지고 오기  START
    async function doSearch(sAction:string) {
        let param = {};
        let sDt = DateUtil.toDateFormat(stDate, "YYYY-MM-DD");
        let eDt = DateUtil.toDateFormat(enDate, "YYYY-MM-DD");

        if(sAction =='search'){
           param = {
               "ST_DATE": sDt,
               "EN_DATE": eDt,
               "TSK_REQ_NO": tskReqNo,
               "TSK_NM": tskNm,
               "TSK_REQ_USERNM": tskReqNm,
               // "PERSON_ID": "75WO57Y6663377A620",
           };
        } else {
            param = {
               "ST_DATE": sDt,
               "EN_DATE": eDt,
               // "PERSON_ID": "75WO57Y6663377A620",
           };
        }

        const response:any = await CommonUtil.execute({
            url: 'usr_2115',
            data: param
        });

//         console.log(param);

        //전체ROW개수
        totalCnt = Object.keys(response.REC).length;
        setTotalRowCnt(Object.keys(response.REC).length);
        //전체데이터
        let result = response.REC;
        // @ts-ignore
        if(typeof result == 'undefined'){
            alert('data is not loaded!!!')
            return;
        }

        //데이터 처리
        ib.data = result;

        // @ts-ignore
        sheet.loadSearchData(result);  //data 로딩 처리
        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
        // @ts-ignore
        makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

    }

    //====== 그리드 데이터 가지고 오기  END

    //====== 그리드 페이징 처리
    // @ts-ignore
    const makePageIndex = function (tp:number) {
      try {
        if (tp == null) {
            //@ts-ignore
            currentPage = -1;
            return;
        }

        // @ts-ignore
        if (document.getElementById('pageNavi').firstChild) {
          // @ts-ignore
          document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
        }

        // @ts-ignore
        currentPage = tp;
        // @ts-ignore
        let sr = totalCnt // 전체 조회 건수
        // @ts-ignore
        let page = showRowCnt; // 페이지당 레코드 수
        let thispage = tp; // 현재 페이지
        let pagecnt = 5; // 한번에 표시할 페이지 개수
        let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
        let li, tt, a;
        let ul = document.createElement('DIV');
        // @ts-ignore
        ul.style.textAlign = 'center';

        let k = 1;

        if (thispage !== 1) {
          let ul_sub = document.createElement('DIV');
          ul_sub.className ="group";
          li = document.createElement('Button');
          li.className = 'item first';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          tt = document.createTextNode('<<');
          addEventHandler(li, 'click', pageMove, 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);

          li = document.createElement('Button');
          li.className = 'item prev';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, tp - 1);
          tt = document.createTextNode('<');
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);
        }

        sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
        let ul_sub2 = document.createElement('DIV');
        ul_sub2.className ="group";
        for (let i = sr; i < (sr + pagecnt); i++) {
          if (i <= lastpage) {
            li = document.createElement('Button');
            li.className ="item";
            a = document.createElement('a');
            a.style.cursor = 'pointer';
            tt = document.createTextNode(String(i));
            addEventHandler(li, 'click', pageMove, i);
            if (i === tp) {
              li.className ="item active";
            }
            a.appendChild(tt);
            li.appendChild(a);
            ul_sub2.appendChild(li);
            ul.appendChild(ul_sub2);
          }
        }

        if (thispage < lastpage) {
          let ul_sub3 = document.createElement('DIV');
          ul_sub3.className ="group";
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          li = document.createElement('Button');
          li.className = 'item next';
          tt = document.createTextNode('>');
          addEventHandler(li, 'click', pageMove, tp + 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);

          li = document.createElement('Button');
          li.className = 'item last';
          tt = document.createTextNode('>>');
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, lastpage);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);
        }

        ul.className = 'pg';
        // @ts-ignore
        document.getElementById('pageNavi').appendChild(ul);
      } catch (ex) {
        // @ts-ignore
        alert(ex.message);
      }
    }

    //페이지 이동
    // @ts-ignore
    const pageMove = function (cPage:number) {
      // @ts-ignore
      sheet.goToPageByIndex(cPage);

    }

    //페이지 이동 이벤트 핸들러
    // @ts-ignore
    const addEventHandler = function (obj, evtName, func, param) {
      if (obj.addEventListener) { // all browsers except IE before version 9
        obj.addEventListener(evtName, function () { func(param); }, false);
      } else if (obj.attachEvent) { // IE before version 9
        obj.attachEvent('on' + evtName, function () { func(param); });
      }
    }

    //인풋 엔터체크
    const activeEnter = (e) => {
        if(e.key === "Enter") {
            doSearch('search');
        }
    }

    // 팝업 Open > ibSheet init
    async function onAfterOpen() {
        ib.create()

        return () => {
          // @ts-ignore
            IBSheet.disposeAll(true);
        }
    }

    // 팝업 Close
    async function onClose() {
        setModal2115IsOpen(false);
        // @ts-ignore
        IBSheet.disposeAll(true);
    }

    function gotoPay(){
        if(!isAllChk){
            alertModal();
            return false;
        }else{
            setModal2115IsOpen(true)
        }
    }


    // if(!loadFinish)
    //     return (
    //         <PageLoading />
    //     )
    // else
	return (
		<PageContainer >
			<LayoutAside />
            <Suspense fallback={<PageLoading/>}>
                <div className='fww-con'>
                    <Breadcrumb gnbIdx={2} lnbIdx={2}/>
                    <main className="fww-main">
                        <Suspense fallback={<PageLoading/>}>
                            <ViewLazyContent contentObj={contentObj}/>
                        </Suspense>
                        <section className="fund-section">
                            <form name="" action="" method="" className="biz-agree-list">
                                <div className="hz-root hz-gap8 mb15">
                                    <label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
                                        <input id="ch-all" className="ip-ch" type="checkbox" checked={isAllChk}
                                               onChange={(e) => checkBoxHandler(e)}/>
                                        <span className="check"></span>
                                        <span className="txt">전체 동의</span>
                                    </label>
                                    <p className="tx-msg"><span className="fc-pri">(※ 아래 조건을 충족하지 않을 경우, 동반성장 투자재원 지급 신청이 반려될 수 있습니다)</span>
                                    </p>
                                </div>
                                <div className="tb tb-narrow">
                                    <table data-type="file">
                                        <caption></caption>
                                        <colgroup>
                                            <col width="90px"/>
                                            <col/>
                                            {/*<col width="230px"/>*/}
                                        </colgroup>
                                        <tbody>
                                        {tbAgree.map((tbAgree, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <label htmlFor={"ch-t" + tbAgree.id}
                                                           className="hz-item ip-ch-label ip-ch-18">
                                                        <input id={"ch-t" + tbAgree.id} className="ip-ch"
                                                               type="checkbox"
                                                               checked={tbAgree.checked}
                                                               onChange={(e) => checkBoxHandler(e)}/>
                                                        <span className="check"></span>
                                                    </label>
                                                </td>
                                                <td className="ta-left">{tbAgree.text}</td>
                                                {/*<td>{tbAgree.guide}</td>*/}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </section>
                        <div className="hz-root hz-right hz-gap10 mt30">
                            <Button color="pri" size="md" onClick={() => gotoPay()}>지급정산신청</Button>
                        </div>
                    </main>
                </div>
            </Suspense>
            <ModalPopup
                open={modal2115IsOpen}
                title="수행 과제 선택"
                size="xlg"
                onClose={() => onClose()}
                onAfterOpen={() => onAfterOpen()}
            >
                <div className="modal-con">
                    <div className="modal-tskana">
                        <div className="fo fo-col2 mb15">
                            <div className="inner">
                                <div className="fo-item fo-item fo-m-1-3">
                                    <p className="fo-key">신청기간</p>
                                    <div className="fo-value">
                                        <div className="hz-root hz-gap5">
                                            <UIDatePicker className="hz-item" value={stDate}
                                                          valueChanged={(value) => setStDate(value)}/>
                                            <span className="hz-item">~</span>
                                            <UIDatePicker className="hz-item" value={enDate}
                                                          valueChanged={(value) => setEnDate(value)}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">과제번호</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={tskReqNo}
                                                 placeholder={"과제번호를 입력하세요."}
                                                 valueChanged={(value) => setTskReqNo(value)}
                                                 onKeyEnter={(e) => activeEnter(e)}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">과제명</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={tskNm} placeholder={"과제명을 입력하세요."}
                                                 valueChanged={(value) => setTskNm(value)}
                                                 onKeyEnter={(e) => activeEnter(e)}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">신청자</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={tskReqNm}
                                                 placeholder={"신청자명을 입력하세요."}
                                                 valueChanged={(value) => setTskReqNm(value)}
                                                 onKeyEnter={(e) => activeEnter(e)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hz-root hz-center mb30">
                            <Button color="pri" size="md" onClick={() => doSearch('search')}>조회</Button>
                        </div>
                        <div className="ibsheet">
                            <div id="sheetDiv">[D] IBSHEET 영역</div>
                        </div>
                        <div id="pageNavi" className="pg"></div>
                    </div>
                </div>

                {/* <div className="modal-bottom">
                    <Button color="pri" size="md">확인</Button>
                </div> */}
            </ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;

function ViewLazyContent({contentObj}: { contentObj: Promise<any> }) {
    const conntent = use(contentObj);
    return (
        <>
            <h1 className="tx tx-hd2">지급정산신청</h1>
            <div className="fund-biz-title">
                {conntent.title}
            </div>
            <section className="fund-section">
                <h3 className="section-title mb15">지급 정산 신청 안내</h3>
                <div className="fund-biz-preview">
                    <UISunEditor value={conntent.cont} displayOnly={true} readOnly={true}/>
                </div>
            </section>
            <section className="fund-section">
                <h3 className="section-title mb15">첨부파일</h3>
                <form name="" action="" method="">
                    <div className="tb tb-narrow">
                        <UI.FileDownloadSimpleMode
                            value={conntent.fileValue}
                            rowNumber={true}
                            viewMode={"table"}/>
                    </div>
                </form>
            </section>
        </>
    )
}